var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerminalBoxLine = function SvgTerminalBoxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 3.25h13.5a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H3.25A.75.75 0 0 1 2.5 16V4a.75.75 0 0 1 .75-.75M4 4.75v10.5h12V4.75zm6 7.5h4.5v1.5H10zM7.5 10 5.38 7.879l1.06-1.061L9.622 10 6.44 13.182l-1.062-1.061z"
  })));
};
export default SvgTerminalBoxLine;